import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import host from '../../urlPath';
//******* 
 

 

//=---------- READ
export const showReceiveMsgData = createAsyncThunk("showReceiveMsgData", async (scheduledt, { rejectWithValue }) => {

        const response = await fetch(`${host}/receive_msg_history.php`, {
        method: "GET", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})
 

//*************************************** FOR API END *************************


export const receiveMsgList = createSlice({
    name: "receiveMsgList",
    initialState: {
        receiveMsgData: [], 
        loading: false,
        error: null, 
    },
 
 
    //*************************************** FOR API START *************************
    extraReducers: (builder) => { 
 

        //---------------------- FOR SELECT ---------------------------
        builder.addCase(showReceiveMsgData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showReceiveMsgData.fulfilled, (state, action) => {
            state.loading = false; 
            state.receiveMsgData = action.payload  
        })
        builder.addCase(showReceiveMsgData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------
 

        //*************************************** FOR API END ************************* 
    },

});
export default receiveMsgList.reducer; 